import React, { useEffect } from "react";

export const SuccessNewTransferStep = (props) => {
  return (
    <>
      <div className="create-transfer-header">
        <h4 className="create-transfer-title"><span className="yellow">{Drupal.t("Success!")}</span></h4>
      </div>
      <div className="create-transfer-body-content">
        <div className="create-transfer-description">
          {Drupal.t("You’ve added a bank transfer. If you have multiple administrators, someone other than yourself will need to approve the transfer.")}
        </div>
      </div>
    </>
  );
};
